import { LoadingButton } from "@mui/lab";
import {
	Box,
	Button,
	Card,
	CardContent,
	Checkbox,
	FormControl,
	FormControlLabel,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import {
	type UseFormRegister,
	type UseFormSetValue,
	type UseFormWatch,
} from "react-hook-form";
import type { IFairStallList } from "src/Utils/type";

const stallTypes = [
	{ label: "STALL", value: "STALL" },
	{ label: "CORNER STALL", value: "CORNER STALL" },
	{ label: "PAVILION", value: "PAVILION" },
	{ label: "SEMI-PAVILION", value: "SEMI-PAVILION" },
];

const hallOptions = [
	{ label: "Harmony", value: "Harmony" },
	{ label: "Celebrity", value: "Celebrity" },
	{ label: "Carnival", value: "Carnival" },
	{ label: "MilkyWay", value: "MilkyWay" },
];

const statusOptions = [
	{ label: "Available", value: "available" },
	// { label: "Booked", value: "booked" },
	{ label: "Reserved", value: "reserved" },
];

interface Props {
	isPending: boolean;
	defaultValues?: IFairStallList;
	buttonText?: string;
	register: UseFormRegister<any>;
	setValue?: UseFormSetValue<any>;
	watch?: UseFormWatch<any>;
}

const StallForm = ({
	isPending,
	register,
	defaultValues,
	buttonText = "Submit",
	setValue,
	watch,
}: Props) => {
	return (
		<Card>
			<CardContent>
				<Grid container spacing={2}>
					<Grid item xs={12} md={6}>
						<FormControl fullWidth required>
							<InputLabel>Select Hall</InputLabel>
							<Select
								{...register("fair_stall_hall_name")}
								label='Select Hall'
								defaultValue={
									defaultValues?.fair_stall_hall_name
								}
							>
								{hallOptions?.map((option) => (
									<MenuItem
										key={option.value}
										value={option.value}
									>
										{option.label}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Grid>
					<Grid item xs={12} md={6}>
						<FormControl fullWidth required>
							<InputLabel>Stall Type</InputLabel>
							<Select
								{...register("fair_stall_type")}
								label='Stall Type'
								defaultValue={defaultValues?.fair_stall_type}
							>
								{stallTypes.map((option) => (
									<MenuItem
										key={option.value}
										value={option.value}
									>
										{option.label}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Grid>
					<Grid item xs={12} md={6}>
						<TextField
							fullWidth
							label='Fair Stall Number'
							required
							{...register("stall_no")}
						/>
					</Grid>

					<Grid item xs={6}>
						<TextField
							fullWidth
							label='Fair Stall Base Price'
							required
							type='number'
							{...register("fair_stall_price", {
								valueAsNumber: true,
								min: 0,
							})}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label='Early Bird Price'
							required
							type='number'
							{...register("early_bird_price", {
								valueAsNumber: true,
								min: 0,
							})}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label='Super Early Bird Price'
							required
							type='number'
							{...register("super_early_bird_price", {
								valueAsNumber: true,
								min: 0,
							})}
						/>
					</Grid>
					{defaultValues && (
						<Grid item xs={12} md={6}>
							<FormControl fullWidth required>
								<InputLabel>Change Status</InputLabel>
								<Select
									defaultValue={
										defaultValues.fair_stall_available_status
									}
									{...register("fair_stall_available_status")}
									label='Change Status'
								>
									{statusOptions.map((item) => (
										<MenuItem
											key={item.value}
											value={item.value}
										>
											{item.label}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
					)}

					<Grid item xs={6}>
						<TextField
							fullWidth
							label='Toab Member Price'
							required
							type='number'
							{...register("toab_member_price", {
								valueAsNumber: true,
								min: 0,
							})}
						/>
					</Grid>
					<Grid item xs={12} md={6}>
						<FormControlLabel
							label='Air Condition'
							{...register("fair_stall_air_conditioned")}
							control={
								<Checkbox
									defaultChecked={
										defaultValues?.fair_stall_air_conditioned
											? true
											: false
									}
								/>
							}
						/>
					</Grid>
				</Grid>
				<Box mt={3}>
					{!isPending ? (
						<Button type='submit' fullWidth variant='contained'>
							{buttonText}
						</Button>
					) : (
						<LoadingButton loading fullWidth variant='outlined'>
							{buttonText}...
						</LoadingButton>
					)}
				</Box>
			</CardContent>
		</Card>
	);
};

export default StallForm;
